import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  contentType: PropTypes.string,
  title: PropTypes.string,
});
